
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Sürdürülebilirlik raporlaması neden önemlidir?',
      answer: 'Sürdürülebilirlik raporlaması, işletmelerin çevresel ve sosyal etkilerini şeffaf bir şekilde paylaşmasını sağlar. Bu, yatırımcılar, müşteriler ve diğer paydaşlar için güven oluşturur, risk yönetimini geliştirir ve uzun vadeli değer yaratımına katkıda bulunur. Ayrıca, TSRS gibi yasal gereklilikleri karşılamak ve rekabet avantajı elde etmek için de kritik öneme sahiptir. Türkiye\'de SPK\'nın TSRS zorunluluğu ile birlikte sürdürülebilirlik raporlaması artık büyük şirketler için yasal bir gereklilik haline gelmiştir.'
    },
    {
      question: 'GRI, CSRD ve TSRS standartları arasındaki fark nedir?',
      answer: 'GRI (Global Reporting Initiative) dünya çapında kabul gören gönüllü raporlama standardıdır ve en yaygın kullanılan sürdürülebilirlik raporlama çerçevesidir. CSRD (Corporate Sustainability Reporting Directive) AB\'nin zorunlu sürdürülebilirlik raporlama direktifi olup, AB\'de faaliyet gösteren büyük şirketler için bağlayıcıdır. TSRS ise Türkiye Sürdürülebilirlik Raporlama Standartları olup, SPK tarafından Türkiye\'deki halka açık şirketler için zorunlu hale getirilmiştir. Her biri farklı gereksinimlere sahip olmakla birlikte, hepsi şeffaflık ve hesap verebilirlik ilkelerini temel alır.'
    },
    {
      question: 'Sürdürülebilirlik danışmanlığı süreci ne kadar sürer?',
      answer: 'Sürdürülebilirlik danışmanlığı süreci, işletmenizin büyüklüğü, sektörü ve hedeflerine bağlı olarak değişiklik gösterir. Temel GAP analizi 2-4 hafta, kapsamlı sürdürülebilirlik stratejisi geliştirme 6-12 hafta, tam GRI/TSRS raporlama süreci ise 3-6 ay sürebilir. Karbon ayak izi hesaplama 4-6 hafta, ESG değerlendirmesi 8-10 hafta alabilir. İlk görüşmede size özel bir zaman çizelgesi ve fiyat teklifi sunuyoruz.'
    },
    {
      question: 'ECOVENTRA\'nın diğer danışmanlık şirketlerinden farkı nedir?',
      answer: '16+ yıllık deneyimimiz, 300+ başarılı proje portföyümüz ve GRI Certified Partner sıfatımız ile sektörde lider konumdayız. TÜV Austria Premium Partner olarak doğrulama hizmetleri de sunuyoruz. SUSTAINES yazılımımız ile teknoloji destekli çözümler sağlıyoruz. Responsible Program\'da yetkilendirilmiş şirket olarak %50 hibe desteği alabilirsiniz. Ayrıca CDP A-List deneyimimiz, SBTi metodoloji uzmanlığımız ve CSRD erken adaptörü olmamız bizi öne çıkarıyor.'
    },
    {
      question: 'Hangi sektörlere hizmet veriyorsunuz?',
      answer: 'Tüm sektörlere hizmet vermekteyiz. Özellikle imalat, enerji, finans, perakende, otomotiv, tekstil, gıda, kimya, madencilik ve teknoloji sektörlerinde geniş deneyimimiz bulunmaktadır. Her sektörün kendine özgü sürdürülebilirlik riskleri ve fırsatları için sektörel uzmanlığımızı geliştirdik. Holding yapılarından KOBİ\'lere kadar her büyüklükteki şirkete uygun çözümler sunuyoruz.'
    },
    {
      question: 'Sürdürülebilirlik raporlaması maliyeti nedir?',
      answer: 'Maliyet, rapor türü, şirket büyüklüğü ve kapsamına göre değişir. Temel GRI raporu 25.000₺\'den, TSRS raporu 30.000₺\'den, CSRD raporu ise €15.000\'dan başlamaktadır. Karbon ayak izi hesaplama 18.000₺\'den, ESG değerlendirmesi ise proje bazlı fiyatlandırılır. İlk danışmanlık görüşmesi ücretsizdir ve size özel detaylı teklif sunuyoruz. Responsible Program kapsamında %50 hibe desteği alabilirsiniz.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Sık Sorulan Sorular
          </h2>
          <p className="text-xl text-gray-600">
            Sürdürülebilirlik danışmanlığı hakkında merak ettikleriniz
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-emerald-600 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 animate-in slide-in-from-top-2 duration-200">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-emerald-50 rounded-2xl p-8">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Başka sorularınız mı var?
            </h3>
            <p className="text-gray-600 mb-6">
              Uzman ekibimizle ücretsiz görüşme yaparak tüm sorularınızın yanıtını alabilirsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="tel:+905326230183"
                className="inline-flex items-center justify-center px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-medium"
              >
                <i className="ri-phone-line mr-2"></i>
                Hemen Arayın
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, sürdürülebilirlik danışmanlığı hakkında bilgi almak istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
              <a
                href="mailto:info@ecoventra.com"
                className="inline-flex items-center justify-center px-6 py-3 border border-emerald-600 text-emerald-600 rounded-lg hover:bg-emerald-50 transition-colors font-medium"
              >
                <i className="ri-mail-line mr-2"></i>
                E-posta Gönderin
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
